import { Control, Controller, useFormContext } from 'react-hook-form';

import { TextField, TextFieldProps } from '@mui/material';

type Props = Omit<TextFieldProps, 'type' | 'onChange' | 'inputProps'> & {
  name: string;
  control?: Control<any>;
  step?: number;
  minValue?: number;
  maxValue?: number;
};

export default function ControlledNumericField({
  name,
  control: propControl,
  step = 0.01,
  minValue,
  maxValue,
  variant = 'outlined',
  ...textFieldProps
}: Props) {
  const control = propControl || useFormContext()?.control;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          value={field.value}
          onChange={({ target: { value } }) => {
            field.onChange(value === '' ? null : Number(value));
          }}
          type="number"
          inputProps={{
            step: step,
            min: minValue,
            max: maxValue
          }}
          variant={variant}
          error={!!fieldState?.error?.type}
          helperText={fieldState?.error?.message}
          fullWidth
          size="small"
          {...textFieldProps}
        />
      )}
    />
  );
}
